var map = {
	"./aquaman5_en.png": "MYR1",
	"./aquaman5_esp.png": "AXg3",
	"./aquaman5_th.png": "n04P"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "J1zu";


//////////////////
// WEBPACK FOOTER
// ./src/assets/lucas ^\.\/aquaman5_.*\.png$
// module id = J1zu
// module chunks = 1